import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import EventIcon from "../ui/forms/event-icon";

//TODO: remove unnecessary icons in the future
import {
  faArrowUpRightFromSquare,
  faClock,
  faRemove,
  faChevronRight,
  faChevronLeft,
  faLocationDot,
  faAngleRight,
  faInfoCircle,
  faCheck,
  faCircleCheck,
  faStar
} from "@fortawesome/pro-regular-svg-icons";

//TODO: remove unnecessary icons in the future
library.add(
  faArrowUpRightFromSquare,
  faClock,
  faRemove,
  faChevronRight,
  faChevronLeft,
  faLocationDot,
  faAngleRight,
  faInfoCircle,
  faCheck,
  faCircleCheck,
  faStar
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("event-icon", EventIcon);
